import React, { useState } from 'react';
import Image from 'next/image';
import { EventData } from '@/types/event';
import fixNewsContent from '@/lib/SVG_Render';

export const EventsCard = React.memo(function EventsCard(props: EventData) {
    const { name, content, event_date, media } = props;
    const [isHovered, setIsHovered] = useState(false);
    
    const imageUrl = media?.[0]?.url || "/default.jpg"; // Use a dedicated, optimized placeholder

    return (
        <div
            className="h-full w-full relative rounded-md group overflow-hidden cursor-pointer"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {/* Image */}
            <div className="relative aspect-3/2 rounded-md">
                <Image
                    src={imageUrl}
                    fill
                    alt={name || 'event image'} // Use event name for better accessibility
                    className="object-cover rounded-md"
                    loading="lazy"
                    sizes="(max-width: 640px) 100vw, (max-width: 768px) 50vw, (max-width: 1024px) 33vw, 25vw"
                    // Consider placeholder="blur" if you have base64 blur data for `imageUrl`
                />
            </div>

            {/* Text Overlay */}
            <div
                className="absolute bottom-0 left-0 w-full bg-primary text-white backdrop-blur-md p-2 lg:p-4 rounded-b-md transform group-hover:translate-y-0 transition-all duration-500"
            >
                <div className="flex items-center space-x-1">
                    <p className="text-xs lg:text-sm">{event_date}</p>
                </div>

                <div>
                    <h1 className="text-sm sm:text-lg md:text-sm lg:text-lg my-2 font-semibold line-clamp-1 md:line-clamp-2 leading-normal">
                        {name}
                    </h1>

                    {/* Conditionally render dangerouslySetInnerHTML only when hovered */}
                    <div
                         className="prose text-sm line-clamp-4 max-h-0 overflow-hidden group-hover:max-h-40 transition-all duration-800"
                    >
                        {isHovered && content && (
                            <div dangerouslySetInnerHTML={{ __html: fixNewsContent(content) }} />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
});